export const SET_TASKTAG = 'TASKTAGS/SET_TASKTAG'
export const SET_TASKTAGS = 'TASKTAGS/SET_TASKTAGS'
export const SET_CONTACTS = 'TASKTAGS/SET_CONTACTS'
